<template>
  <div class="filter-component" v-if="renderComponent">
    <template v-if="!isEditMode">
      <blade
        class="filter-overlay"
        name="filter-content"
        :title="`${$t('NOTE_FILTER_HEADER')}:`"
      >
        <div class="filter-form">
          <sh-button-deprecated
            @click="resetFilters"
            ghost
            size="xsmall"
            class="reset-button">
            {{ $t('CONTENT_FILTER_RESET_DEFAULTS_CTA') }}
          </sh-button-deprecated>
          <filter-tag-group class="filter-tags" :tags="Object.values(tags)" @click="changeFilterType"/>

          <form @submit.prevent="onSubmit">
            <categories-fieldset
              v-if="categories.length > 0 && currentFilterType === FILTER_TYPES.CATEGORY"
              v-model="filters.categories"
              :categories="categories"/>

            <generic-error v-else/>

            <sh-button
              primary
              type="submit"
              :fullWidth="true"
            >
              {{ $t('NOTE_FILTER_FILTER_APPLY_CTA') }}
            </sh-button>
          </form>

        </div>
      </blade>
      <sh-button
        class="filter-button"
        @click="showFiltersBlade"
      >
        {{ $t('NOTE_FILTERS_OPEN_LABEL') }}
      </sh-button>
    </template>

    <template v-else>
      <sh-button class="filter-button" size="large" disabled>
        {{ $t('NOTE_FILTER_OPEN_LABEL') }}
      </sh-button>
    </template>
  </div>
</template>

<script>
import UIMixin from '~/mixins/ui'

import FilterTagGroup from '~/components/filter-tag-group'
import CategoriesFieldset from '~/components/fieldsets/categories'

import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapNoteGetters, mapActions: mapNoteActions } = createNamespacedHelpers('content/notes')
const { mapGetters: mapCategoryGetters } = createNamespacedHelpers('content/categories')
const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

const FILTER_TYPES = {
  CATEGORY: 'CATEGORY'
}

export default {
  name: 'FilterComponent',

  mixins: [
    UIMixin
  ],

  components: {
    FilterTagGroup,
    CategoriesFieldset
  },

  data () {
    return {
      FILTER_TYPES,
      currentFilterType: FILTER_TYPES.CATEGORY,
      filters: {
        categories: []
      },
      renderComponent: true
    }
  },

  mounted () {
    const { query } = this
    this.rehydrateNoteFilters({ query })
    const { categories } = this.noteFilters
    this.filters.categories = categories
  },

  computed: {
    ...mapNoteGetters(['noteFilters', 'areFiltersApplied', 'defaultFilters']),
    ...mapCategoryGetters({ noteCategories: 'resources' }),
    ...mapJssGetters(['isEditMode']),

    categories () {
      return this.noteCategories.sort(
        (a, b) => a.categoryName.localeCompare(b.categoryName)) || []
    },

    tags () {
      return {
        [FILTER_TYPES.CATEGORY]: {
          name: this.$t('EXPLORE_EVENTS_FILTER_CATEGORIES_LABEL'),
          count: this.currentFilterType === FILTER_TYPES.CATEGORY,
          type: FILTER_TYPES.CATEGORY
        }
      }
    },
    query () {
      return this.$route.query
    }
  },

  methods: {
    ...mapNoteActions(['fetchAllNotes', 'setNoteFilters', 'resetNoteFilters', 'unsetNoteFilters', 'rehydrateNoteFilters']),

    async fetchNotes () {
      if (this.areFiltersApplied) {
        await this.fetchAllNotes()
      }
    },

    showFiltersBlade (evt) {
      this.$ui.modal.target(evt.currentTarget)
      this.$ui.modal.open('filter-content')
    },
    applyFilters () {
      this.$ui.modal.close('filter-content')
      if (this.$router.currentRoute.path === '/notes/categories') {
        this.fetchNotes()
      }
    },
    goToPath (path, params) {
      this.$router.push({ path, query: params })
    },
    onSubmit () {
      if (this.filters.categories.length > 0) {
        const { filters } = this
        this.setNoteFilters({ filters })
        this.applyFilters()
        this.goToPath('/notes/categories', {
          categories: filters.categories.join(',')
        })
      } else {
        this.resetFilters()
      }
    },
    changeFilterType (type) {
      this.currentFilterType = type
    },
    resetFilters () {
      this.filters.categories = []
      this.$ui.modal.close('filter-content')
      this.goToPath('/notes', null)
    }
  }
}
</script>

<style lang="scss" scoped>

.filter-component {
  display: block;
  text-align: center;
  padding: $space-050 0;

  .filter-button {
    min-width: 240px;
    width: auto;
  }

  .filter-overlay {
    text-align: initial;
  }
}
</style>
